<template>
  <div class="animated fadeIn">
    <div>
      <!--            <a href="#" class="btn btn-sm btn-outline-dark float-right" @click="descargarPDF"><i class="fa fa-file-pdf-o"></i>  </a>-->
      <!--            <a href="#" class="btn btn-sm btn-outline-dark float-right" @click="printDiv"><i class="fa fa-print"></i>  </a>-->
      <!-- <a href="#" class="btn btn-sm btn-success float-right ml-1"><i class="fa fa-send"></i> Enviar</a> -->
    </div>

    <div id="areaImprimir">
      <div class="text-left"></div>

      <b-row> </b-row>
      <b-row>
        <b-col>
          <b-img
            :src="img"
            left
            fluid
            style="max-height: 100px; max-width: 250px"
            alt="Responsive image"
            class="rounded pb-0"
          ></b-img>
          <h1 class="text-right">EXPORT INVOICE #{{ shipment.boarding_number }}</h1>
          <p class="text-right">
            {{ shipment.invoice_date | moment }} <br />
            Pais: {{ shipment.country.name }} <br />
            <span v-if="shipment.shipment_type.name === 'Maritimo'">Nombre de nave: {{ shipment.vessel }}</span>
          </p>
          <a href="#" class="float-right text-black-50" @click="descargarPDF"><i class="fa fa-download"></i></a>
        </b-col>
      </b-row>
      <b-row class="mb-0">
        <b-col lg="6">
          <b-card>
            <h5 class="border-bottom border-secondary pb-1 mt-0 text-center text-uppercase">CONSIGNEE INFORMATION</h5>
            <b>COMPANY</b>: {{ shipment.consignee_company.name }}<br />
            <b> R.U.T</b>: {{ shipment.consignee_company.company_number }}<br />
            <b>ADDRESS</b>: {{ shipment.consignee_company.address1 }}, {{ shipment.consignee_company.address2 }} <br />
            <b>CONTACT</b>: {{ shipment.consignee_company.contact_name }}<br />
            <b>MAIL</b>: {{ shipment.consignee_company.contact_email }}<br />
            <b>PHONE</b>:{{ shipment.consignee_company.contact_phone }}
          </b-card>
        </b-col>
        <b-col lg="6">
          <b-card>
            <h5 class="border-bottom border-secondary pb-1 text-center text-uppercase">NOTIFY</h5>
            <b>COMPANY</b>: {{ shipment.notify_company.name }}<br />
            <b> R.U.T</b>: {{ shipment.notify_company.company_number }}<br />
            <b>ADDRESS</b>: {{ shipment.notify_company.address1 }}, {{ shipment.notify_company.address2 }} <br />
            <b>CONTACT</b>: {{ shipment.notify_company.contact_name }}<br />
            <b>MAIL</b>: {{ shipment.notify_company.contact_email }}<br />
            <b>PHONE</b>:{{ shipment.notify_company.contact_phone }}
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mb-0">
        <b-col lg="12">
          <b-card>
            <h5 class="border-bottom border-secondary pb-2 text-center text-uppercase">EXPORTER INFORMATION</h5>

            <span style="text-align: left">
              <b>COMPANY</b>: {{ shipment.exporter_company.company_name }}<br />
              <b>RUT</b>: {{ shipment.exporter_company.company_number }}<br />
              <b>ADDRESS</b>: {{ shipment.exporter_company.address1 }}, {{ shipment.exporter_company.address2 }}<br />
              <span v-if="shipment.shipment_type.id == 1"
                ><b>TRANSPORT MODE:</b> {{ shipment.shipping_line.name }} ({{ shipment.shipment_type.name }})<br
              /></span>
              <span v-if="shipment.shipment_type.id == 2"
                ><b>TRANSPORT MODE:</b> {{ shipment.air_line.name }} ({{ shipment.shipment_type.name }})<br
              /></span>
              <span v-if="shipment.shipment_type.id == 1"><b>BL:</b> {{ shipment.bill_loading }}<br /></span>
              <span v-if="shipment.shipment_type.id == 1"
                ><b>LOADING PORT:</b> {{ shipment.loading_port.name }}<br
              /></span>
              <span v-if="shipment.shipment_type.id == 1"
                ><b>DESTINATION PORT:</b> {{ shipment.destination_port.name }}<br
              /></span>
              <span v-if="shipment.shipment_type.id == 2"
                ><b>AIRPORT DEPARTURE:</b> {{ shipment.airport_departure.name }}<br
              /></span>
              <span v-if="shipment.shipment_type.id == 2"
                ><b>AIRPORT ARRIVAL:</b> {{ shipment.airport_arrival.name }}<br
              /></span>
              <b>ETD</b>: {{ shipment.etd | moment }}<br />
              <b>ETA</b>: {{ shipment.eta | moment }}<br />
            </span>

            <span style="position: absolute; right: 30px; top: 55px">
              <span v-if="shipment.shipment_type.id == 2"><b>AWB:</b> {{ shipment.bl_awb }}<br /></span>
              <b>CURRENCY</b>: {{ shipment.currency }}<br />
              <b>SALE FORM</b>: {{ shipment.sale_mode }}<br />
              <b>PAYMENT FORM</b>: {{ shipment.payment_form }}<br />
              <b>SALE CONDITION</b>: {{ shipment.sale_clause }}<br />
              <b>FREIGHT / PAY</b>: {{ shipment.freight_mode }}<br />
              <b>PO NUMBER</b>: {{ shipment.po_number }}<br />
              <div v-if="shipment.shipment_type.id == 1"><b>BOOKING #</b>: {{ shipment.booking_number }}</div>
              <div v-if="shipment.shipment_type.id == 1"><b>CONTAINER #</b>: {{ shipment.containers }}</div>
              <b>INSURANCE</b>: {{ shipment.insurance | decimal }} {{ shipment.currency }}<br />
              <b>FREIGHT</b>: {{ shipment.freight | decimal }} {{ shipment.currency }}<br />
            </span>
          </b-card>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card> <b>NOTES</b>: {{ shipment.note }} </b-card>
        </b-col>
      </b-row>

      <b-row class="mb-2">
        <b-col lg="12">
          <b-card>
            <h5 class="pb-2 text-center text-uppercase">DETAILS</h5>
            <table class="table table-sm" style="width: 100%">
              <thead>
                <tr>
                  <th scope="col" style="text-align: center">PRODUCT</th>
                  <th scope="col" style="text-align: center">VARIETY <br />CONDITION</th>
                  <th scope="col" style="text-align: center">FORMAT</th>
                  <th scope="col" style="text-align: center">PALLET</th>
                  <th scope="col" style="text-align: center">
                    BOX <br />
                    QUANTITY
                  </th>
                  <th scope="col" style="text-align: center">PRICE/BOX <br />({{ shipment.currency }})</th>
                  <th scope="col" style="text-align: center">GROSS<br />WEIGHT</th>
                  <th scope="col" style="text-align: center">NET<br />WEIGHT</th>
                  <th scope="col" style="text-align: center">TOTAL <br />({{ shipment.currency }})</th>
                </tr>
              </thead>
              <tbody>
                <template v-for="row in shipment.shipment_detailed">
                  <tr>
                    <td scope="col" style="text-align: center">{{ row.product.name }}</td>
                    <td scope="col" style="text-align: center">
                      {{ row.variety.name }} <br />
                      {{ row.condition }}
                    </td>
                    <td scope="col" style="text-align: center">{{ row.container.name }}</td>
                    <td scope="col" style="text-align: center">{{ row.pallet_quantity }}</td>
                    <td scope="col" style="text-align: center">{{ row.box_quantity }}</td>
                    <td scope="col" style="text-align: center">{{ row.price_per_box }}</td>
                    <td scope="col" style="text-align: center">{{ row.gross_weight }}</td>
                    <td scope="col" style="text-align: center">{{ row.net_weight }}</td>
                    <td scope="col" style="text-align: right">
                      $ {{ totalCalculated(row.box_quantity, row.price_per_box) }}
                    </td>
                  </tr>
                </template>
                <tr>
                  <td scope="col" style="text-align: center"><b></b></td>
                  <td scope="col" style="text-align: center"></td>
                  <td scope="col" style="text-align: center"></td>
                  <td scope="col" style="text-align: center">
                    <b>{{ pallet_quantity }}</b>
                  </td>
                  <td scope="col" style="text-align: center">
                    <b>{{ box_quantity }}</b>
                  </td>
                  <td scope="col" style="text-align: center"></td>
                  <td scope="col" style="text-align: center">
                    <b>{{ gross_weight | decimal }}</b>
                  </td>
                  <td scope="col" style="text-align: center">
                    <b>{{ net_weight | decimal }}</b>
                  </td>
                  <td scope="col" style="text-align: right">
                    <b>$ {{ subtotal | decimal }}</b>
                  </td>
                </tr>
                <tr>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: center; border-top: none"></td>
                  <td scope="col" style="text-align: left"><b>TOTAL:</b></td>
                  <td scope="col" style="text-align: right">
                    <b>$ {{ subtotal | decimal }}</b>
                  </td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import moment from "moment";
import numeral from "numeral";
numeral.locale("es");

export default {
  name: "ReportInstructivoEmbarqueAereo",
  created() {},
  props: ["idBording", "shipment"],
  data() {
    return {
      img: "",
      pallet_quantity: 0,
      box_quantity: 0,
      gross_weight: 0,
      net_weight: 0,
      shipment_detailed: [],
      total: 0,
      subtotal: 0,
      current_date: moment(new Date()).format("DD-MM-YYYY HH:mm")
    };
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD-MM-YYYY");
    },
    decimal: function (value) {
      return numeral(parseFloat(value)).format("0,0.00");
    }
  },
  computed: {},

  methods: {
    totalCalculated(a, b) {
      let value = parseFloat(a) * parseFloat(b);
      return numeral(value).format("0,0.00");
    },

    printDiv: function () {
      const prtHtml = document.getElementById("areaImprimir").innerHTML;

      let stylesHtml = "";

      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      const WinPrint = window.open("", "", "left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0");

      WinPrint.document.write(`<!DOCTYPE html>
      <html>
        <head>
          ${stylesHtml}
        </head>
        <body>
          ${prtHtml}
        </body>
      </html>`);

      WinPrint.document.close();
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
    },
    descargarPDF: function () {
      var element = document.getElementById("areaImprimir").innerHTML;

      var opt = {
        margin: 0.25,
        image: { type: "jpeg", quality: 0.5 },
        html2canvas: { scale: 2 },
        filename: "Factura Exportación #" + this.shipment.boarding_number + ".pdf",
        jsPDF: { unit: "in", format: "letter", orientation: "portrait" }
      };

      html2pdf(element, opt);
    },
    calcular: function () {
      this.pallet_quantity = 0;
      this.box_quantity = 0;
      this.gross_weight = 0;
      this.net_weight = 0;

      this.subtotal = 0;
      this.total = 0;

      this.shipment_detailed = this.shipment.shipment_detailed;

      for (var indice in this.shipment_detailed) {
        this.pallet_quantity += parseFloat(this.shipment_detailed[indice].pallet_quantity);
        this.box_quantity += parseFloat(this.shipment_detailed[indice].box_quantity);
        this.gross_weight += parseFloat(this.shipment_detailed[indice].gross_weight);
        this.net_weight += parseFloat(this.shipment_detailed[indice].net_weight);

        this.subtotal +=
          parseFloat(this.shipment_detailed[indice].box_quantity) *
          parseFloat(this.shipment_detailed[indice].price_per_box);
      }

      this.pallet_quantity = this.pallet_quantity;
      this.box_quantity = this.box_quantity;
      this.gross_weight = this.gross_weight.toFixed(2);
      this.net_weight = this.net_weight.toFixed(2);

      this.total = parseFloat(this.subtotal) + parseFloat(this.shipment.freight) + parseFloat(this.shipment.insurance);

      this.total = this.total.toFixed(2);

      this.subtotal = this.subtotal.toFixed(2);
    }
  },
  mounted() {
    if (this.shipment.exporter_company.logo) {
      this.img = this.shipment.exporter_company.logo;
    } else {
      this.img = localStorage.getItem("img");
    }
  },
  beforeMount() {}
};
</script>

<style>
table {
  page-break-inside: auto;
}
tr {
  page-break-inside: avoid;
  page-break-after: auto;
}

#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }
  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }
  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
